import * as React from "react";
import styles from "./AppointmentSetting.module.scss";
import FindClinicianCard from "../../FindClinicianCard/FindClinicianCard";
import { IClient } from "intake_shared/src/types";

interface ApptSettingTabWrapperProps {
    children: React.ReactNode;
    client: IClient;
}

const ApptSettingTabWrapper: React.FC<ApptSettingTabWrapperProps> = ({
    children,
    client,
}) => {
    return (
        <div>
            <div className={styles.findClinicianWrapper}>
                <FindClinicianCard client={client} />
            </div>
            {children}
        </div>
    );
};

export default ApptSettingTabWrapper;
